export default __webpack_public_path__ + "static/309-cba4fe8d3f87b181f9238a378f080bac.gif";